/* unplugin-vue-components disabled */import { render } from "./ai-vertical-select.vue?vue&type=template&id=d0085738&scoped=true"
import script from "./ai-vertical-select.vue?vue&type=script&lang=js"
export * from "./ai-vertical-select.vue?vue&type=script&lang=js"

import "./ai-vertical-select.vue?vue&type=style&index=0&id=d0085738&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0085738"],['__file',"src/components/ai-chat/ai-assistant/ai-input/ai-vertical-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d0085738"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d0085738', __exports__)) {
    api.reload('d0085738', __exports__)
  }
  
  module.hot.accept("./ai-vertical-select.vue?vue&type=template&id=d0085738&scoped=true", () => {
    api.rerender('d0085738', render)
  })

}


export default __exports__